import { AxiosResponse } from "axios";

import { appConstants } from "../config/app-constants";
import { IPostOfficeRes } from "../config/interfaces";
import InitApi from "./init";

class GlobalSettingsApi {
  static _instance: GlobalSettingsApi;

  static getInstance = () => {
    if (this._instance) {
      return this._instance;
    }
    this._instance = new GlobalSettingsApi();
    return this._instance;
  };

  _apiSvc;

  constructor() {
    this._apiSvc = InitApi.getInstance();
  }

  getGlobalSettingByKey = async (
    key: "TERMS_AND_CONDITIONS" | "PRIVACY_POLICY" | "COOKIES_POLICY" | "ADMIN_EMAIL"
  ): Promise<AxiosResponse> => {
    return this._apiSvc.get(`${appConstants.apiUrl}/global-setting/key/${key}`);
  };

  getGlobalSettings = async (offset: number, count: number): Promise<AxiosResponse> => {
    let url = `global-setting?offset=${offset}`;
    if (count) {
      url += `&count=${count}`;
    }
    return this._apiSvc.get(`${appConstants.apiUrl}/${url}`);
  };

  createGlobalSettings = async (data: any): Promise<AxiosResponse> => {
    return this._apiSvc.post(`${appConstants.apiUrl}/global-setting`, data);
  };

  updateGlobalSettings = async (
    id: number | string | undefined,
    data: any
  ): Promise<AxiosResponse> => {
    return this._apiSvc.put(`${appConstants.apiUrl}/global-setting/single/${id}`, data);
  };

  getStateByPinCode = async (pincode: string): Promise<IPostOfficeRes[]> => {
    const URL = `https://api.postalpincode.in/pincode/${pincode}`;

    const requestOptions: any = {
      method: "GET",
      redirect: "follow"
    };

    const response = await fetch(URL, requestOptions);
    return response.json();
  };
}

export default GlobalSettingsApi;
